import Modal from 'developer_components/newModal';
import {createElement, error, hasWebpSupport, declension} from 'methods/utils';
import Swiper from 'swiper';
import {/*Navigation, Pagination, */Thumbs} from 'swiper/modules';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/pagination';

const webpSupport = hasWebpSupport();

const apartmentPhotogalleryNavIcon = {
    prev: (
        `<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">`
        + `<path d="M11.5 13.5L7 9L11.5 4.5" stroke="#2A2536" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>`
        + `</svg>`
    ),
    next: (
        `<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">`
        + `<path d="M7.5 13.5L12 9L7.5 4.5" stroke="#2A2536" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>`
        + `</svg>`
    ),
};

function ensureApartmentPhotogalleryNav($photogalleryMain) {
    if (!$photogalleryMain) {
        return;
    }

    ['prev', 'next'].forEach((direction) => {
        const $button = $photogalleryMain.querySelector(`.swiper-button-${direction}`);

        if ($button && !$button.querySelector('svg')) {
            $button.innerHTML = apartmentPhotogalleryNavIcon[direction];
        }
    });
}

function renderApartmentOptionIcon(option) {
    if (option.icon) {
        return `<div class="Apartment-modal__option-icon">${option.icon}</div>`;
    }

    return `<div class="Apartment-modal__option-icon option_${option.id}"></div>`;
}

/**
 * Модалка на странице объекта
 */
function ApartmentModal(data, $element, options = {}) {
    Modal.call(this, $element, options);

    this.data = data;

    this.$photogalleryMain = this.$element.querySelector('.js-photogallery-main');
    this.$photogalleryCarousel = this.$element.querySelector('.js-photogallery-carousel');
    this.$note = this.$element.querySelector('.js-note');
    this.$noteMore = this.$element.querySelector('.js-note-more');
    this.$noteMoreWrapper = this.$element.querySelector('.js-note-more-wrapper');

    // потенциальный фикс пробелов в вёрстке
    this.$note.innerHTML = this.$note.innerHTML.trim();

    if (this.$note.textContent.length > this.options.note.length) {
        const originalText = this.$note.innerHTML;
        this.$note.textContent = this.$note.textContent.slice(0, this.options.note.length);
        this.$noteMoreWrapper.classList.add('is-active');
        this.$noteMore.addEventListener('click', this._onNoteMoreClickEvent.bind(this, originalText));
    }

    this.photogalleryCarouselSwiper = new Swiper(this.$photogalleryCarousel, {
        slidesPerView: 4,
        spaceBetween: 8,
        watchSlidesProgress: true,
    });

    this.photogalleryMainSwiper = new Swiper(this.$photogalleryMain, {
        slidesPerView: 'auto',
        spaceBetween: 4,
        pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        thumbs: {
            swiper: this.photogalleryCarouselSwiper,
        },
        // навигация и пагинация работают и без добавления в модули, при добавлении навигация дублирует клики
        modules: [/*Navigation, Pagination, */Thumbs],
        breakpoints: {
            960: {
                slidesPerView: 1,
                spaceBetween: 8,
            },
        },
        on: {
            click: (swiper, event) => {
                const $image = event.target.closest('.js-photogallery-main-image');
                this.emit('photogallery:click', $image, $image.dataset.pos);
            },
        },
    });

    ensureApartmentPhotogalleryNav(this.$photogalleryMain);
}

ApartmentModal.prototype = Object.create(Modal.prototype);
Object.defineProperty(ApartmentModal.prototype, 'constructor', {
    value: ApartmentModal,
    enumerable: false,
    writable: true,
});

ApartmentModal.prototype.setOptions = function (options = {}) {
    Modal.prototype.setOptions.call(this, Object.assign({
        note: {
            length: 150,
        },
    }, options));
}

ApartmentModal.prototype._onNoteMoreClickEvent = function (originalHtml, e) {
    this.$note.innerHTML = originalHtml;
    this.$noteMoreWrapper.classList.remove('is-active');
}

ApartmentModal.make = function (data, options = {}) {
    data = JSON.parse(JSON.stringify(data));
    data.rooms_count = data.rooms_count ? parseInt(data.rooms_count, 10) : null;
    data.places_count = data.places_count ? parseInt(data.places_count, 10) : null;
    data.square = data.square ? parseInt(data.square, 10) : null;

    const infos = [
        {
            icon: (
                `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.00333 14.0067C11.3189 14.0067 14.0067 11.3189 14.0067 8.00333C14.0067 4.68778 11.3189 2 8.00333 2C4.68778 2 2 4.68778 2 8.00333C2 11.3189 4.68778 14.0067 8.00333 14.0067Z" stroke="#2A2536" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 10.6667V8" stroke="#2A2536" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 5.3335H8.00667" stroke="#2A2536" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`
            ),
            text: [
                data.rooms_count ? declension(data.rooms_count, '%d комната', '%d комнаты', '%d комнат').replace('%d', data.rooms_count) : null,
                data.places_count ? declension(data.places_count, '%d спальное место', '%d спальных места', '%d спальных мест').replace('%d', data.places_count) : null,
                data.square ? `${data.square} м<sup>2</sup>` : null,
            ].filter(line => line).map(line => `<span>${line}</span>`).join('<span>·</span>'),
        },
        {
            icon: (
                `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3359 8.04443H2.66927C1.9326 8.04443 1.33594 8.6411 1.33594 9.37777V11.3331C1.33594 11.7011 1.6346 11.9998 2.0026 11.9998H14.0026C14.3706 11.9998 14.6693 11.7011 14.6693 11.3331V9.37777C14.6693 8.6411 14.0726 8.04443 13.3359 8.04443Z" stroke="#2A2536" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2.33594 8.08667V8.04467V8.04467C2.33594 6.91533 3.25127 6 4.3806 6H5.93594C6.89327 6 7.66927 6.776 7.66927 7.73333V8.04467" stroke="#2A2536" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7.67188 8.04467V8.04467C7.67188 6.91533 8.58721 6 9.71654 6H11.6279C12.7572 6 13.6725 6.91533 13.6725 8.04467V8.04467V8.08667" stroke="#2A2536" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2.67188 6.9265V4.6665C2.67188 3.56184 3.56721 2.6665 4.67188 2.6665H11.3385C12.4432 2.6665 13.3385 3.56184 13.3385 4.6665V6.9265" stroke="#2A2536" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14.0052 12V13.3333" stroke="#2A2536" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2.00521 12V13.3333" stroke="#2A2536" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`
            ),
            text: data.bed_title,
        },
    ];

    const foodOptions = data.options.filter(group => group.title == 'Питание');
    const otherOptions = data.options.filter(group => group.title != 'Питание');

    const $element = Modal.createFromHTML(
        `<div class="Apartment-modal__container">
            <div class="Apartment-modal__head">
                <h3 class="Apartment-modal__title">${data.title}</h3>
                <button class="Apartment-modal__close js-modalClose" title="Закрыть">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.307 7.69289C16.6976 8.08342 16.6976 8.71658 16.307 9.10711L13.4142 12L16.307 14.8929C16.6976 15.2834 16.6976 15.9166 16.307 16.3071C15.9165 16.6976 15.2834 16.6976 14.8928 16.3071L11.9999 13.4142L9.10705 16.3071C8.71653 16.6976 8.08336 16.6976 7.69284 16.3071C7.30231 15.9166 7.30231 15.2834 7.69284 14.8929L10.5857 12L7.69284 9.10711C7.30231 8.71658 7.30231 8.08342 7.69284 7.69289C8.08336 7.30237 8.71653 7.30237 9.10705 7.69289L11.9999 10.5858L14.8928 7.69289C15.2834 7.30237 15.9165 7.30237 16.307 7.69289Z" fill="#2A2536"/>
                    </svg>
                </button>
            </div>
            <div class="Apartment-modal__body">
                <div class="Apartment-modal__details">
                    <div class="Apartment-modal__details-photogallery">
                        <div class="Apartment-modal__photogallery">
                            <div class="Apartment-modal__photogallery-main swiper js-photogallery-main">
                                <div class="swiper-wrapper">
                                    ${data.photos.map((photo, index) => (
                                        `<div class="Apartment-modal__photogallery-image${photo.is_vertical ? ' Apartment-modal__photogallery-image--vertical' : ''} swiper-slide js-photogallery-main-image" data-pos="${index}">
                                            <img src="${photo.photo_720 || photo.big_photo}">
                                        </div>`
                                    )).join('')}
                                </div>
                                <div class="swiper-pagination"></div>
                                <div class="swiper-button-prev">
                                    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.5 13.5L7 9L11.5 4.5" stroke="#2A2536" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div class="swiper-button-next">
                                    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.5 13.5L12 9L7.5 4.5" stroke="#2A2536" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="Apartment-modal__photogallery-carousel swiper js-photogallery-carousel">
                                <div class="swiper-wrapper">
                                    ${data.photos.map(photo => (
                                        `<div class="Apartment-modal__photogallery-image swiper-slide">
                                            <img src="${photo.photo_720 || photo.big_photo}">
                                        </div>`
                                    )).join('')}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="Apartment-modal__details-information">
                        <div class="Apartment-modal__infos">
                            ${infos.filter(info => info.text).map(info => (
                                `<div class="Apartment-modal__info">
                                    <div class="Apartment-modal__info-icon">${info.icon}</div>
                                    <div class="Apartment-modal__info-text">${info.text}</div>
                                </div>`
                            )).join('')}
                        </div>
                        <div class="Apartment-modal__note js-note">${data.note}</div>
                        <div class="Apartment-modal__more-wrapper js-note-more-wrapper">
                            <button type="button" class="Apartment-modal__more js-note-more" title="Показать скрытый текст">Показать ещё</button>
                        </div>
                    </div>
                </div>
                ${[foodOptions, otherOptions].filter(groups => groups.length).map(groups => (
                    `<div class="Apartment-modal__groups">
                        ${groups.map(group => (
                            `<div class="Apartment-modal__group">
                                <div class="Apartment-modal__group-title">${group.title}</div>
                                <div class="Apartment-modal__group-options">
                                    ${group.options.map(option => (
                                        `<div class="Apartment-modal__option">
                                            ${renderApartmentOptionIcon(option)}
                                            <div class="Apartment-modal__option-title">${option.title}</div>
                                        </div>`
                                    )).join('')}
                                </div>
                            </div>`
                        )).join('')}
                    </div>`
                )).join('')}
            </div>
            <div class="Apartment-modal__footer">
                <a href="#" class="Apartment-modal__order">Оставить заявку</a>
            </div>
        </div>`,
        {
            className: 'Apartment-modal',
        }
    );

    return new ApartmentModal(data, $element, options);
}

export default ApartmentModal;
